import ConfigurazioneAgenda from "..";
const routes = [{ name: "ConfigurazioneAgendaBoxList", path: "/configurazioneagendabox", component: ConfigurazioneAgenda.ConfigurazioneAgendaBoxListPage, meta: { title: "Configurazione Agenda Box" } }];
export default routes;
